import React from 'react';
import {Row, Col, Card} from 'react-materialize';

import stop_child_labour from '../../images/stop_child_labour.png';
import ic_launcher_round from '../../images/ic_launcher_round.png';
import logos_about from '../../images/logos_about.png';

import {FormattedMessage, FormattedHTMLMessage} from 'react-intl';

const Sobre = () => (

    <Card>

        <Row>
            <div className={"text-center"} align="center">
                <img src={ic_launcher_round} className={"img"} alt={"Aquasafe logo"} width={"200"} height={"200"}/>
            </div>
        </Row>

        <br/>

        <Row>
        <div>

            <div align="center">
                <h5><p><b><FormattedMessage id={"about"} defaultMessage={"SOBRE O AQUASAFE"}/></b></p></h5>
            </div>

            <br/>
            <p align="justify"><FormattedMessage id={"about.text1"} defaultMessage={"AquaSafe é um aplicativo educacional sobre saúde e segurança ocupacional na aquicultura. É uma plataforma de atenção à saúde do trabalhador na aquicultura, com ações dirigidas aos trabalhadores e produtores da aquicultura, estudantes e profissionais."}/></p>
            <p align="justify"><FormattedMessage id={"about.text2"} defaultMessage={"São abordados os principais riscos, fontes e perigos nas atividades de trabalho. Informações sobre prevenção, uso de equipamentos de segurança e danos à saúde estão disponíveis no app."}/></p>
            <p align="justify"><FormattedMessage id={"about.text3"} defaultMessage={"AquaSafe pode ser utilizado como plataforma de checagem e avaliação de riscos ocupacionais, através do checklist e outras ferramentas. Auxilia na tomada de decisões de métodos, técnicas ou medidas de prevenção de acidentes, controles de engenharia e/ou controles administrativos e uso de EPIs."}/></p>
            <p align="justify"><FormattedMessage id={"about.text4"} defaultMessage={"A aprendizagem pode ainda ser realizada através do quiz que é um ambiente altamente interativo."}/></p>
            <br/>
            <p align="justify"><b><FormattedMessage id={"about.text5"} defaultMessage={"Este aplicativo não substitui gerenciamento e avaliações de profissionais capacitados 'in loco'."}/></b></p>
            <br/>
        </div>
        </Row>
        <Row>
            <div className={"text-center"} align="center">
                <img src={stop_child_labour} className={"img"} alt={"Stop child labour"} width={"300"} height={"200"} />
            </div> </Row>

        <br/>

        <Row>
            <p><FormattedMessage id={"about.text6"} defaultMessage={"Desenvolvido com apoio do CNPQ."}/></p>
            <p> <mark> <FormattedMessage id={"about.text7"} defaultMessage={"Classificação livre."}/> </mark> </p>
        </Row>


        <Row>
            <div align="center">
                <h5> <p><b><FormattedMessage id={"team"} defaultMessage={"EQUIPE"}/></b></p> </h5> </div>

            <div className={"margin"}>
            <b><FormattedMessage id={"team.1"} defaultMessage={"Coordenadora:"}/></b>
                <p>Dra. Lissandra Souto Cavalli (DDPA)</p>
            </div>
            <div className={"margin"}>
            <b><FormattedMessage id={"team.2"} defaultMessage={"Desenvolvedores:"}/></b>
                <p>Bruno Gomes Tavares dos Santos (UFCSPA)</p>
                <p>Flavielle Blanco Marques (UFCSPA)</p>
                <p>Giovani Nicolas Bettoni (UFCSPA)</p>
            </div>
            <div className={"margin"}>
            <b><FormattedMessage id={"team.3"} defaultMessage={"Equipe principal AquaSafe:"}/></b>

            <p>Dra. Lissandra Souto Cavalli (DDPA)</p>
            <p>Bruno Gomes Tavares dos Santos (UFCSPA)</p>
            <p>Flavielle Blanco Marques (UFCSPA)</p>
            <p>Giovani Nicolas Bettoni (UFCSPA)</p>
                <p>Dr. Silvio Cazella (UFCSPA)</p>
                <p>Dra. Rebecca Mitchell (Macquarie University, Austrália)</p>
                <p>Dra. Luceni Hellebrandt</p>
                <p>Dr. Kirill Buketov (IUF)</p>
                <p>Dr. Andrew Waterson (University of Stirling, Escócia)</p>
                <p>Dr. Mohamed Jeebhay (University of Cape Town, África do Sul)</p>
                <p>Dra. Dorothy Ngajilo (University of Cape Town, África do Sul)</p>
                <p>Dr. 'Deji Adeoye (Federal University of Agriculture, Nigéria)</p>
            </div>
            <div className={"margin"}>
            <b><FormattedMessage id={"team.4"} defaultMessage={"Equipe de consultoria técnica:"}/> </b>

                <p>Dr. Arpita Sharma (ICAR-CIFE)</p>
                <p>Dra. Maria Helena Fermino (DDPA)</p>
                <p>Dr. Benito Brito (DDPA)</p>
                <p>Dra. Kelly Cristina Tagliari de Brito (DDPA)</p>
                <p>Julio Bastola (ferramentas da qualidade e gestão)</p>
            </div>
            <div className={"margin"}>
            <b><FormattedMessage id={"team.5"} defaultMessage={"Equipe de atualização do COVID-19:"}/> </b>

                <p>Dr. Lissandra Souto Cavalli (DDPA/SEAPDR-RS)</p>
                <p>Dr. Barbara Neis (Memorial University, Newfoundland and Labrador, Canada)</p>
                <p>Dr. Andrew Watterson (University of Stirling, Scotland)</p>
                <p>Eduarda Serpa (UFCSPA | DDPA/SEAPDR-RS)</p>
                <p>Willian de Vargas (UFCSPA | DDPA/SEAPDR-RS)</p>
            </div>
        </Row>

        <Row>
            <div align="center">
                <h5><p><b><FormattedMessage id={"institution"} defaultMessage={"INSTITUIÇÕES"}/></b></p></h5> </div>

            <br/>
            <div className={"institution-center"} align="center">
                <img src={logos_about} className={"img"} alt={"Institutions"} width={"300"} height={"300"}/>
            </div>
        </Row>

        <Row>
            <div align="center">
                <h5><p><b><FormattedMessage id={"reference"} defaultMessage={"REFERÊNCIAS UTILIZADAS"}/></b></p></h5> </div>

            <br/>
            <div className={"margin"} align="justify">
            <p>Ícones: flaticon.com</p>
            <p>Checklist: github.com/edupooch/AquaSaude-Camarao</p>
            <p>Quiz: github.com/tulikavijay/react-projects</p>
            <p>http://www.wcb.pe.ca/DocumentManagement/Document/pub_aquaculturesafetycodeofpractice.pdf</p>
            <p>https://www.aquaculturecouncilwa.com/files/5814/0462/8115/WAAquaIndustryOHSCode2002.pdf</p>
            <p>https://novascotia.ca/lae/healthandsafety/docs/FishSafe.pdf</p>
            <p>https://www.dpc.mar.mil.br/sites/default/files/normam05.pdf</p>
            <p>https://www.ccaimo.mar.mil.br/sites/default/files/solas_indice-2014_2.pdf</p>
            <p>http://www.hse.gov.uk/toolbox/ppe.htm</p>
            <p>http://www.fao.org/cofi/aq/90408/en/</p>
            <p>http://www.fao.org/cofi/46125-015d659aed398efe120a5953620684aea.pdf</p>
            <p>IUF meat division - AMR</p>
            <p>http://www.who.int/foodsafety/areas_work/antimicrobial-resistance/en/</p>
            <p>http://apps.who.int/iris/bitstream/handle/10665/258970/9789241550130-eng.pdf?sequence=1</p>
            <p>OHSAS 18001</p>
            <p>ILO</p>
            <p>Koonse B. 2012. Good aquaculture practices to minimize bacterial resistance. In: Improving biosecurity through prudent and responsible use of veterinary medicines in aquatic food production. FAO fisheries and Aquaculture Technical Paper 547. Rome, Italy, 208p. </p>
            <p>Myers ML, Durborow RM. Aquacultural safety and health. In: Edmir Carvalho ed. Health and Environment in Aquaculture. Croatia: InTech; 2012. doi: 10.5772/29258. Available at: http://www.intechopen.com/books/health-and-environment-in-aquaculture/aquacultural-safety-and-health. </p>
            <p>Myers ML, Cole HP. Simple solutions for reduced fish farm hazards. J Agromedicine. 2009;14:150–156. </p>
            <p>Myers ML, Durborow RM, Cole HP. 2012. Inherently safer - Aquacultural work: Hierarchical hazard controls. Professional Safety: 44-51. </p>
            </div>
        </Row>
    </Card>

);

export default Sobre;